import axios from "axios";
import { API } from "../../utils/index";
const instance = axios.create();

export const postUserinfo = async (userinfo) => {
  return instance.post(`${API}/user-info`, userinfo);
};
